export const initialValues = {
    station: null,
    brand: null,
    serie: '',
    capacity: null,
    fixedAssetNum: '',
    description: '',
    status: 'NUEVO',
}

export const requiredValues = {
    station: { required: true },
    brand: { required: true },
    serie: { required: true },
    capacity: { required: true },
    fixedAssetNum: { required: true },
    description: { required: true },
}